/**
 * @file main.tab.tsx
 * @description Основная таба формы тестового случая (test-case). 
 * Содержит поля для детального описания тест-кейса: описание с поддержкой вложений, сценарий выполнения теста,
 * ожидаемый результат и ссылки на связанные ресурсы. Поддерживает drag-and-drop загрузку файлов через DragNDropZone.
 * Использует rich text редакторы для форматированного ввода текста и AttachmentsRichText для работы с вложениями.
 * @author AI Assistant
 * @created 2025-09-04
 * @updated 2025-09-04
 * @dependencies [react, @src/types, @components/form-controls/collapsed/rich-text, @components/form-controls/drag-n-drop-zone, @components/form-controls/collapsed/attachments-rich-text]
 * @related-files [@forms/test-case/test-case.form.tsx, @components/form-controls/collapsed/rich-text/rich-text.component.tsx, @components/form-controls/drag-n-drop-zone/drag-n-drop-zone.component.tsx]
 */

import { tabProps } from '@src/types';
import { RichText } from '@components/form-controls/collapsed/rich-text';
import { DragNDropZone } from '@components/form-controls/drag-n-drop-zone';
import { AttachmentsRichText } from '@components/form-controls/collapsed/attachments-rich-text';

export const Main = ({ control }: tabProps) => {
    return (
        <DragNDropZone className="flex flex-col h-full gap-[1.0585vmin]" name="attachments" control={control}>
            <AttachmentsRichText
                label="Описание"
                name="description"
                control={control}
                placeholder="Добавьте описание задачи, чтобы исполнителю было понятно, что нужно сделать в рамках задачи"
            />

            <RichText label="Сценарий" name="playbackScenario" control={control} />

            <RichText label="Ожидаемый результат" name="expectedResult" control={control} />

            <RichText label="Ссылки" name="links" control={control} />
        </DragNDropZone>
    );
};
